import React from "react";
import KatlasStatusPill from "@/components/KatlasStatusPill";

const Audience = ({ tag, copy, testId }) => (
    <div
        data-testid={testId}
        className="border-l border-slate-200 pl-5 py-1"
    >
        <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-slate-500 mb-2">
            {tag}
        </div>
        <p className="text-sm leading-relaxed text-slate-700">{copy}</p>
    </div>
);

export const Hero = ({ status }) => {
    return (
        <section
            data-testid="hero-section"
            className="relative overflow-hidden border-b border-slate-200 bg-white"
        >
            <div
                aria-hidden="true"
                className="absolute inset-0 opacity-[0.06] pointer-events-none"
                style={{
                    backgroundImage:
                        "url(https://images.unsplash.com/photo-1571627144817-1dbd724adbbe?crop=entropy&cs=srgb&fm=jpg&w=1600&q=70)",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            />
            <div className="relative mx-auto max-w-7xl px-6 lg:px-10 pt-10 pb-16">
                <div className="flex flex-wrap items-center gap-3 mb-10">
                    <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-slate-500">
                        KATLAS / Cierge Foundation
                    </div>
                    <span className="h-1 w-1 rounded-full bg-slate-400" />
                    <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-slate-500">
                        CAR · Custody · Authority · Receipts
                    </div>
                    <div className="ml-auto">
                        <KatlasStatusPill status={status} />
                    </div>
                </div>

                <div className="grid grid-cols-12 gap-8 lg:gap-12">
                    <div className="col-span-12 lg:col-span-8">
                        <h1
                            data-testid="hero-title"
                            className="font-heading text-4xl lg:text-6xl font-bold tracking-tighter text-slate-900 leading-[1.02]"
                        >
                            PromptCierge
                        </h1>
                        <p
                            data-testid="hero-tagline"
                            className="mt-5 font-heading text-xl lg:text-2xl text-slate-700 max-w-2xl leading-snug"
                        >
                            Bounded prompts · LLM budget discipline · signed
                            decision receipts.
                        </p>
                        <p
                            data-testid="hero-required-line"
                            className="mt-8 max-w-2xl text-base text-slate-600 border-l-2 border-slate-900 pl-4"
                        >
                            <span className="font-semibold text-slate-900">
                                AI may draft, compare or recommend.
                            </span>{" "}
                            Authorised roles decide. KATLAS signs the receipt.
                        </p>
                    </div>

                    <aside className="col-span-12 lg:col-span-4 space-y-5">
                        <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-slate-500">
                            What this demo shows
                        </div>
                        <Audience
                            testId="audience-project-teams"
                            tag="For project teams"
                            copy="PromptCierge helps convert repeated or risky prompt requests into bounded, reusable patterns."
                        />
                        <Audience
                            testId="audience-reviewers"
                            tag="For reviewers"
                            copy="PromptCierge records the authority gate: who approved the model route, what evidence was allowed, what was withheld and what outcome followed."
                        />
                        <Audience
                            testId="audience-finance"
                            tag="For finance / ops leaders"
                            copy="PromptCierge helps reduce unnecessary LLM calls by replacing repeated prompting with approved patterns, smaller models, deterministic checks or human review routes."
                        />
                    </aside>
                </div>
            </div>
        </section>
    );
};

export default Hero;
